/**
 * Wave 10 zod-mandate — runtime schemas for the UUID v7 helpers.
 *
 * @example
 * ```ts
 * import { UuidV7TimestampSchema, IsUuidV7InputSchema } from './Uuid.schema'
 * UuidV7TimestampSchema.parse(Date.now())
 * ```
 */
import { z } from 'zod'

export const UuidV7TimestampSchema = z.number().int().nonnegative().optional()

// `isUuidv7` accepts arbitrary input by design (`unknown`); the schema is a
// pass-through used only so `validateIsUuidv7Input` has a uniform contract.
export const IsUuidV7InputSchema = z.unknown()

export type UuidV7TimestampInput = z.infer<typeof UuidV7TimestampSchema>
